import { createAction } from 'shared';

export const setToken = createAction('SET_TOKEN', 'token');
export const deleteToken = createAction('DELETE_TOKEN');
